import React from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useGlobalStore } from '../../state/globalStore';
import Sidebar from '../../components/layout/Sidebar';
import SharedHeader from '../../components/layout/SharedHeader';
import SimpleQuestionDetailPage from './pages/SimpleQuestionDetailPage';
import SupportQuestionsPage from './pages/SupportQuestionsPage';
import AttachmentsPage from './pages/AttachmentsPage';
import BulkActionsPage from './pages/BulkActionsPage';
import { NAVIGATION_ITEMS } from './constants';

const QuestionsApp = ({ user: userProp, backUrl = '/my-account/dashboard' }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user: globalUser, userProfile, initUser, loading: userLoading } = useGlobalStore();
  
  // Use prop user if provided (from AdminHQ), otherwise use global user
  const user = userProp || globalUser;

  // Initialize user from global store if not already loaded
  React.useEffect(() => {
    console.log('QuestionsApp - User check:', { 
      globalUser: globalUser ? 'exists' : 'null',
      userProp: userProp ? 'exists' : 'null',
      finalUser: user ? 'exists' : 'null',
      userId: user?.id,
      userLoading
    });
    if (!globalUser) {
      console.log('QuestionsApp - No user found, initializing...');
      initUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalUser, initUser]);

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar
        items={NAVIGATION_ITEMS}
        activeItem={location.pathname}
        onItemClick={(itemId) => navigate(itemId)}
        productName="Questions"
        user={user}
        userProfile={userProfile}
        onBackToProducts={() => window.location.href = backUrl}
      />
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <SharedHeader
          user={user}
          userProfile={userProfile}
          userRole={null}
          productName="Questions"
        />
        
        {/* Main Content */}
        <main className="flex-1 overflow-auto p-6">
              <Routes>
                <Route path="dealrooms" element={<SupportQuestionsPage user={user} isDealQuestions={true} />} />
                <Route path="dealroom/:projectId" element={<SupportQuestionsPage user={user} isDealQuestions={true} isSingleDealroom={true} />} />
                <Route path="support" element={<SupportQuestionsPage user={user} />} />
                <Route path="detail/:id" element={<SimpleQuestionDetailPage />} />
                <Route path="attachments" element={<AttachmentsPage />} />
                <Route path="bulk-actions" element={<BulkActionsPage />} />
                <Route index element={<Navigate to="dealrooms" replace />} />
              </Routes>
        </main>
      </div>
    </div>
  );
};

export default QuestionsApp;